import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";

import { makeStyles } from "@material-ui/styles";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

export const AcfFullWidthImageBlock = (props) => {
  const classes = useStyles();

  let image = props.block.blockFullWidthImage.image;

  return (
    <>
      {image.localFile && (
        <div className="gatsby-image-wrapper blocks-gallery-item" style={{
          width: '100vw',
          marginLeft: '50%',
          transform: 'translateX(-50%)'
        }}>
          <div
            style={{
              paddingBottom:
                (image.mediaDetails.height / image.mediaDetails.width) *
                  100 +
                "%",
            }}
          />
          <img
            src={image.localFile.publicURL}
            alt={image.altText}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center center",
            }}
          />
        </div>
      )}
      {!image.localFile && (
        <div className="gatsby-image-wrapper blocks-gallery-item" style={{
          width: '100vw',
          marginLeft: '50%',
          transform: 'translateX(-50%)'
        }}>
          <img src={image.sourceUrl} alt={image.altText} />
        </div>
      )}
    </>
  );
};

AcfFullWidthImageBlock.propTypes = {
  attributes: PropTypes.object.isRequired,
};

export const AcfFullWidthImageBlockFragment = graphql`
  fragment AcfFullWidthImageBlock on WpBlock {
    ... on WpAcfFullWidthImageBlock {
      name
      attributes {
        className
      }
      blockFullWidthImage {
        image {
          id
          altText
          sourceUrl
          localFile {
            id
            publicURL
            childImageSharp {
              gatsbyImageData(
                quality: 90
                placeholder: BLURRED
                formats: [AUTO, WEBP]
                transformOptions: { fit: COVER, cropFocus: CENTER }
              )
            }
          }
          mediaDetails {
            height
            width
          }
        }
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const AcfFullWidthImageBlockPreview = `
    ... on AcfFullWidthImageBlock { 
        name 
        attributes { 
            className 
        } 
        blockFullWidthImage { 
            image { 
                sourceUrl 
              mediaDetails {
                height
                width
              }
            } 
        } 
    }`;
